// Rosebar DC — global constants

export const ROSEBAR = {
  name: "Rosebar",
  tagline: "Washington DC's Most Iconic Nightlife Experience",
  subtagline: "Exclusive tables. Celebrity appearances. Unforgettable nights.",
  address: "1215 Connecticut Ave NW, Washington, DC 20036",
  phone_text: "(202) 301-8794",
  phone_text_label: "Text 24/7",
  phone_call: "(202) 955-5525",
  phone_call_label: "Mon–Fri 11A–4P",
  email: "info@rosebarlounge.com",
  instagram: "https://www.instagram.com/rosebardc/",
  twitter: "https://twitter.com/rosebardc",
  tiktok: "https://www.tiktok.com/discover/rosebar-lounge-dc",
  google_maps: "https://www.google.com/maps/place/Rosebar+Lounge/@38.906419,-77.041088,15z",
  logo_white: "https://customer-assets.emergentagent.com/job_e9e78a3a-5557-4749-806a-2569ce606b06/artifacts/fw3e63hf_47495ROSEBAR_WHITE_LOGO-red-rose-480x111-207w.webp",
  rose_mark: "https://customer-assets.emergentagent.com/job_rosebar-vip/artifacts/msdn4m7b_fav-icon-290x290.png",
  hours: [
    { day: "Monday", hours: "Closed", closed: true },
    { day: "Tuesday", hours: "11PM – 2AM" },
    { day: "Wednesday", hours: "Closed", closed: true },
    { day: "Thursday", hours: "10PM – 2AM" },
    { day: "Friday", hours: "10PM – 3AM" },
    { day: "Saturday", hours: "10PM – 3AM" },
    { day: "Sunday", hours: "11PM – 2AM" },
  ],
};

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_rosebar-vip/artifacts/gq2ac1is_DN8A7632.jpg";

// Used for static hero crossfade if no video
export const HERO_BACKDROPS = [
  "https://customer-assets.emergentagent.com/job_rosebar-vip/artifacts/gq2ac1is_DN8A7632.jpg",
  "https://customer-assets.emergentagent.com/job_rosebar-vip/artifacts/u5g0bw76_day-17.jpeg",
  "https://customer-assets.emergentagent.com/job_rosebar-vip/artifacts/311arevh_14-1ff51ad5.jpeg",
];

export const NAV_LINKS = [
  { label: "Reservations", to: "/reservations" },
  { label: "Menu", to: "/menu" },
  { label: "Gallery", to: "/gallery" },
  { label: "Experiences", to: "/experiences" },
  { label: "Private Events", to: "/private-events" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const POSITIONS = [
  { code: "security", title: "Security", desc: "Detail-oriented, calm under pressure, trained in crowd management." },
  { code: "bartender", title: "Bartender", desc: "Speed, style, and a flair for premium service." },
  { code: "bottle-service", title: "Bottle Service", desc: "VIP-grade hospitality, the face of every table." },
  { code: "host", title: "Host", desc: "Front-of-house energy. The first impression of Rosebar." },
  { code: "marketing", title: "Marketing", desc: "Storyteller. Social-first. Brand obsessed." },
  { code: "management", title: "Management", desc: "Operational excellence and luxury hospitality experience." },
];

export const MEMBERSHIP_PLANS = [
  {
    code: "rose-monthly",
    name: "Rose",
    cadence: "Monthly",
    price: 99,
    tagline: "The essentials, every weekend.",
    perks: ["Priority Entry until 12AM", "VIP Cover Pricing", "Birthday Bottle Treat", "Early Event Invites"],
  },
  {
    code: "rose-annual",
    name: "Rose",
    cadence: "Annual",
    price: 990,
    badge: "Save 2 Months",
    tagline: "The essentials, year-round.",
    perks: ["Priority Entry until 12AM", "VIP Cover Pricing", "Birthday Bottle Treat", "Early Event Invites"],
  },
  {
    code: "noir-monthly",
    name: "Noir",
    cadence: "Monthly",
    price: 249,
    badge: "Most Popular",
    tagline: "The full Rosebar lifestyle.",
    perks: [
      "Skip-the-Line · Every Night",
      "Complimentary Cover · Always",
      "Celebrity Event Priority Access",
      "Reserved Standing Section",
      "Birthday Bottle + Champagne",
      "Concierge Reservation Line",
    ],
  },
  {
    code: "noir-annual",
    name: "Noir",
    cadence: "Annual",
    price: 2490,
    badge: "Save 2 Months",
    tagline: "The full Rosebar lifestyle.",
    perks: [
      "Skip-the-Line · Every Night",
      "Complimentary Cover · Always",
      "Celebrity Event Priority Access",
      "Reserved Standing Section",
      "Birthday Bottle + Champagne",
      "Concierge Reservation Line",
      "2 Guest Passes / Quarter",
    ],
  },
];

export const PRIVATE_EVENT_TYPES = [
  "Corporate Event",
  "Birthday Celebration",
  "Album Release",
  "Influencer Event",
  "Networking Event",
  "Holiday Party",
  "Brand Activation",
  "Other",
];

// Complimentary GA admission: until 11PM, except Tuesday & Sunday until 12AM (DC time).
export const compAdmissionLabel = (dayOfWeek) =>
  `Complimentary admission until ${["Tuesday", "Sunday"].includes(dayOfWeek) ? "12AM" : "11PM"}`;

export const compAdmissionClosed = (isoDate, dayOfWeek) => {
  if (!isoDate) return false;
  const nowDC = new Date().toLocaleString("sv-SE", { timeZone: "America/New_York" }).replace(" ", "T");
  let cutoff = `${isoDate}T23:00:00`;
  if (["Tuesday", "Sunday"].includes(dayOfWeek)) {
    const d = new Date(`${isoDate}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + 1);
    cutoff = `${d.toISOString().slice(0, 10)}T00:00:00`;
  }
  return nowDC >= cutoff;
};

// Pay in full = table minimum + 10% tax + 20% gratuity (birthday packages are all-inclusive).
export const fullPaymentAmount = (minimum, isPackage) =>
  Math.round(Number(minimum || 0) * (isPackage ? 1 : 1.3) * 100) / 100;

export const RESERVATION_POLICY = {
  title: "Reservation & Late Arrival Policy",
  paragraphs: [
    "All prepayments are non-refundable and non-transferable, with no refunds or credits issued for no-shows or late arrivals.",
    "Please arrive on time for your reservation. Arrivals after 12:00 AM (midnight) are not guaranteed seating, and your table may be released or reassigned to other guests. Table assignments and availability are subject to change based on arrival time and venue capacity.",
    "Thank you for your understanding and cooperation.",
  ],
  short: "All prepayments are non-refundable and non-transferable. Arrivals after 12:00 AM (midnight) are not guaranteed seating.",
};

export const RESERVATION_INFO = {
  deposit_note: "All reservations require a $300 deposit. Deposit is fully credited toward your minimum spend on the night.",
  arrival_window: "Please arrive on time. Arrivals after 12:00 AM (midnight) are not guaranteed seating, and your table may be released or reassigned.",
  dress_code: "Upscale & Stylish. No athletic wear, no oversized graphics, no work boots, no offensive clothing. Management reserves the right of refusal.",
  age: "21+ with valid government-issued ID.",
  cancellation: "All prepayments are non-refundable and non-transferable, with no refunds or credits issued for no-shows or late arrivals.",
  faq: [
    {
      q: "How does the minimum spend work?",
      a: "Your minimum spend is the total you must spend on bottles, mixers, and food at your table. The $300 deposit counts toward that minimum.",
    },
    {
      q: "How many guests can sit at a table?",
      a: "Each table has a recommended capacity (4–12 depending on package). Larger parties should split across multiple tables — reach out to concierge for groups of 12+.",
    },
    {
      q: "Do I get free admission with my table?",
      a: "Yes — your entire party receives complimentary admission until 12AM. After 12AM, standard cover may apply for late additions.",
    },
    {
      q: "Can I bring a custom cake for my birthday?",
      a: "Absolutely. Birthday packages include a complimentary sparkler bottle presentation. Outside cakes are welcome.",
    },
    {
      q: "What happens if I'm late?",
      a: "Arrivals after 12:00 AM (midnight) are not guaranteed seating, and your table may be released or reassigned. Text our concierge at (202) 301-8794 if you're running late and we'll do our best to hold.",
    },
  ],
};
